/* eslint-disable */
import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
  }
}

export default Module;
